// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_pkG","cls2":"UserTaggingPingBodyStyles-cls2_MhW UserTaggingPingBodyStyles-cls1_pkG"};